<template>
  <div id="website" class="columns is-multiline" :class="theme">
    <main-menu></main-menu>
    <transition name="blink" mode="out-in">
      <router-view :key="$route.params.page"></router-view>
    </transition>
    <transition name="fade" mode="out-in">
      <loader :loading="$store.state.loading"></loader>
    </transition>
    <admin-controls v-if="$store.state.isAdmin"></admin-controls>
    <snackbar></snackbar>
    <span
      v-if="$store.state.isAdmin && $store.state.previewTheme && Object.keys($store.state.previewTheme).length > 0"
      class="tag is-danger"
      >{{ $resx("General.ThemePreview") }}</span
    >
    <via-modal :active.sync="authModal" :size="'xs'" @close="resetAuth" :closeOnBackdrop="true" :autoClose="false" :title="$resx('Global.Login')">
      <template slot="body">
        <form>
          <small class="has-text-danger">{{authErrors.join(', ')}}</small>
          <div class="field">
            <div class="control">
              <input
                class="input"
                ref="email"
                type="text"
                :placeholder="$resx('Global.Email')"
                :class="{'is-danger': required.email}"
                @keyup.enter="authorize"
              />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input
                class="input"
                ref="password"
                type="password"
                :placeholder="$resx('Global.Password')"
                :class="{'is-danger': required.pass}"
                @keyup.enter="authorize"
              />
            </div>
          </div>
          <!-- <button type="submit" class="button is-link">Submit</button> -->
        </form>
      </template>
      <template slot="footer">
        <button class="button is-danger" @click="authModal = false">{{ $resx("Buttons.Close") }}</button>
        <button
          type="submit"
          class="button is-success is-pulled-right"
          @click="authorize"
        >
          {{ $resx("Buttons.Login") }}
        </button>
      </template>
    </via-modal>
  </div>
</template>

<script>
import { faTimes } from '@fortawesome/pro-solid-svg-icons'

import viaModal from '@/components/Modal.vue'
import mainMenu from '@/components/MainMenu.vue'
import loader from '@/components/Loader.vue'
import adminControls from '@/components/admin/Controls.vue'
import snackbar from '@/components/admin/Snackbar.vue'
// import mainFooter from '@/components/Footer.vue'

export default {
  name: 'app',
  data () {
    return {
      // cookieAccepted: true,
      theme: process.env.VUE_APP_THEME,
      icons: {
        close: faTimes
      },
      authErrors: [],
      authModal: false,
      required: {
        email: false,
        pass: false
      }
    }
  },
  components: {
    mainMenu,
    loader,
    adminControls,
    snackbar,
    viaModal
  },
  computed: {
    activeLanguage () {
      return this.$store.state.language
    },
    activePage () {
      return this.$store.state.activePage
    }
  },
  head: {
    link: function () {
      return [
        {
          r: 'apple-touch-icon',
          h: '/touch-icon-iphone.png',
          undo: false
        },
        {
          r: 'apple-touch-icon',
          h: '/touch-icon-ipad.png',
          sz: '76x76',
          undo: false
        },
        {
          r: 'apple-touch-icon',
          h: '/touch-icon-iphone-retina.png',
          sz: '120x120',
          undo: false
        },
        {
          r: 'apple-touch-icon',
          h: '/touch-icon-ipad-retina.png',
          sz: '152x152',
          undo: false
        },
        {
          r: 'shortcut icon',
          h: '/favicon.ico',
          undo: false
        },
        {
          r: 'mask-icon',
          h: '/mask-icon.svg',
          color: '#16bae7',
          undo: false
        }
      ]
    }
  },
  methods: {
    authorize (event) {
      event.preventDefault()
      var self = this
      var hasError = false

      self.required.email = false
      self.required.pass = false

      if (self.$refs.email.value === '') {
        self.required.email = true
        hasError = true
      }
      if (self.$refs.password.value === '') {
        self.required.pass = true
        hasError = true
      }

      if (hasError) {
        return false
      }

      self.$store.commit('loading', true)
      self.$auth
        .via_login(self.$refs.email.value, self.$refs.password.value)
        .then(function (response) {
          self.$store.commit('loading', false)
          if (response.status) {
            self.authErrors = []
            self.authModal = false

            self.$store.dispatch('getSitemap', true).then(function () {
              self.$router.replace('/' + self.$store.state.language + '/')
              self.$store.dispatch('activatePage', {
                page: self.$store.state.homepage
              })
              self.$router.go()
            })
          } else {
            self.$store.commit('setAdmin', false)
            self.authErrors.push((response.data.data ? response.data.data.message : self.$resx('General.SomethingWentWrong')))
          }
        })
    },
    resetAuth: function () {
      var self = this
      self.required.email = false
      self.required.pass = false
      self.authErrors = []
    },
    // acceptCookie: function () {
    //   var self = this
    //   self.$cookie.set('via-acc-cookies', true, {
    //     expires: '1Y',
    //     secure: 'true'
    //   })
    //   self.cookieAccepted = true
    // },
    onkey: function (e) {
      var self = this

      if (
        !self.$store.state.isAdmin &&
        (e.key === 'Enter' || e.which === 13 || e.keyCode === 13) &&
        (e.metaKey || e.ctrlKey)
      ) {
        e.preventDefault()
        self.$store.dispatch('getSitemap', true).then(function () {
          if (self.$store.state.isAdmin) {
            self.$store.commit('loading', true)
            window.location.reload()
          } else {
            self.authModal = true
            self.$nextTick(() => {
              self.$refs.email.focus()
            })
          }
        })
      }
    }
  },
  created: function () {
    var self = this
    window.addEventListener('keydown', self.onkey)
    window.onbeforeunload = function () {
      if (self.$store.state.isAdmin && self.$store.state.hasContentChanges) {
        return self.$resx('General.UnsavedChanges')
      }
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('keydown', this.onkey)
  },
  mounted: function () {
    var self = this

    self.$auth.via_init().then(function (loggedin) {
      if (loggedin === false && self.$store.state.isAdmin) {
        self.$store.dispatch('getSitemap')
      }
    })

    var profile = self.$auth.via_getToken()
    if (profile.clt) {
      self.$store.commit('adminLanguage', profile.clt)
    }

    self.$cookie.delete('via-acc-cookies')

    // var cookie = self.$cookie.get('via-acc-cookies')
    // if (cookie) {
    //   self.cookieAccepted = true
    // } else {
    //   self.cookieAccepted = false
    // }
  },
  watch: {
    // '$route.params.page': {
    //   handler: function (val) {
    //     var self = this
    //     if (!self.$auth.via_local().isValid()) {
    //       self.$store.dispatch('logout')
    //     }
    //   },
    //   immediate: true
    // }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.blink-enter-active {
  transition: opacity 0.5s ease-in-out;
}

.blink-enter,
.blink-leave-active {
  opacity: 0;
}

#website {
  margin-bottom: 0;

  // #cookies {
  //   position: fixed;
  //   bottom: 0;
  //   left: 0;
  //   width: 100%;
  //   // height: 100px;
  //   background-color: #383c3f;
  //   overflow: hidden;
  //   padding: 15px 10px;
  //   color: #fcfdfd;
  //   z-index: 9999;
  //   font-size: 14px;
  //   font-weight: 600;
  //   line-height: 22px;
  //   .columns {
  //     margin-top: 0;
  //   }
  // }
}

span.tag {
  position: absolute;
  top: 10px;
  text-transform: uppercase;
  font-weight: 700;
  left: 50%;
  margin-left: -70px;
  width: 140px;
  z-index: 1001;
}
</style>
